















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import NavItem from '@/components/navigation/NavItem.vue';
import { mapActions, mapGetters } from 'vuex';
import Selector from '@/components/language/Selector.vue';
import { User } from '@/model/Profile';
import DashboardIcon from '@/assets/navbar/dashboard.svg?inline';
import CustomerIcon from '@/assets/navbar/customer.svg?inline';
import ProfileIcon from '@/assets/navbar/profile.svg?inline';
import LogoutIcon from '@/assets/navbar/logout.svg?inline';
import AdminIcon from '@/assets/navbar/admin.svg?inline';
import EventFlow from '@/assets/navbar/event-flow.svg?inline';
import ThreeLine from '@/assets/navbar/three-line.svg?inline';
import { EventResponse } from '@/model/Event';

@Component({
    components: {
        CustomerIcon,
        DashboardIcon,
        ProfileIcon,
        LogoutIcon,
        AdminIcon,
        NavItem,
        Selector,
        EventFlow,
        ThreeLine,
    },
    computed: {
        ...mapGetters({
            getEvent: 'eventStorage/getEvent',
        }),
    },
    methods: {
        ...mapActions({
            logout: 'authenticationStorage/logout',
        }),
    },
})
export default class NavBar extends Vue {
    @Prop() user!: User | null;

    isOpen = true;

    getEvent!: EventResponse | null;

    logout!: () => Promise<void>;

    toggle(): void {
        this.isOpen = !this.isOpen;
    }

    onLogout(): void {
        this.logout().finally(() => {
            this.$router.push({ name: 'Login' });
        });
    }
}
